<template>
  <get-started title="Storage">
    <div class="d-flex px-1 py-3 my-3">
      <b-container>
        <b-row>
          <b-col>
            <div class="pr-1">
              <p>
                Captain Storage is an S3 compatible object storage service that
                lets you store and retrieve any amount of data, anytime from
                anywhere on the web. Through a web interface with easy-to-use
                management features organize data that meet specific business
                needs. Each bucket created is to store and serve files. Easily
                allow or block public access to a bucket or to a specific object
                inside a bucket.
              </p>
              <p>
                Captain Storage supports features that help maintain data
                version control, prevent accidental deletions, and data
                replications. With Versioning enabled, it is easy to preserve,
                retrieve, and restore every version of an object stored in
                Captain Storage, which allows recovering from unintentional user
                actions and application failures.
              </p>
            </div>
          </b-col>
          <b-col>
            <div class="pl-1">
              <p>
                Captain Storage supports the use of a bucket as an origin server
                for Captain CDN. Easily encode videos and use Captain Storage
                buckets as outputs of Encoded Video formats.
              </p>
              <b-button
                variant="primary"
                class="mt-1"
                :disabled="initializingStorage"
                @click="startUsingStorage"
              >
                Start Using Storage
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <b-icon-circle
        class="circle-bg"
        font-scale="7.5"
        color="#F6F7F9"
      />
    </div>
  </get-started>
</template>

<script>
import GetStarted from '@/components/start/GetStarted.vue'
import { BIconCircle } from 'bootstrap-vue'

export default {
  name: 'StorageIntro',
  components: { GetStarted, BIconCircle },
  computed: {
    initializingStorage() {
      return this.$store.state.accountBuckets.initializingStorage
    },
  },
  methods: {
    startUsingStorage() {
      this.$router.push({ name: 'add-external-account' })
    },
  },
}
</script>
<style lang="scss" scoped>
.a-bg {
  position: absolute;
  bottom: 35px;
  right: 35px;
}
</style>
